import { serif, siteErrorImage } from 'styles/css-constants';
import { MQ_MEDIUM, MQ_XLARGE } from 'constants/mq';
import css from 'styled-jsx/css';

export default css`
  .ErrorPage__above {
    background: url('${siteErrorImage}') no-repeat center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 75vh;
    margin-bottom: 2em;
  }

  .ErrorPage__above-message {
    background-color: rgba(255, 255, 255, 1);
    padding: 1em 0.5em;
    margin: 0 1em;
    text-align: center;
    box-shadow: 0 4px 6px rgba(240, 195, 88, 0.2), 0 1px 3px rgba(0, 0, 0, 0.3),
      0 2px 12px rgba(0, 0, 0, 0.2);
  }

  .ErrorPage h1 {
    font-weight: bold;
    font-family: ${serif};
    margin-bottom: 0.25em;
    line-height: 1.2;
    font-size: var(--fontScale2);
  }

  .ErrorPage p {
    color: #666;
    font-family: ${serif};
    line-height: 1.35;
  }

  .ErrorPage__below {
    padding: 1rem 0;
    justify-content: center;
    background-color: white;
    z-index: 100;
  }

  @media ${MQ_MEDIUM} {
    .ErrorPage__above-message {
      padding: 2em 1em;
      width: 50vw;
      margin: 0;
    }
  }

  @media ${MQ_XLARGE} {
    .ErrorPage__above-message {
      padding: 2em 1em;
      width: 40vw;
      max-width: 45vw;
    }
    .ErrorPage h1 {
      font-size: var(--fontScale3);
    }
  }
`;
